import styled from "styled-components";

export const ContentWrapper = styled.div`
    margin: 0;
`;

export const IndentedContentWrapper = styled.div`
    margin: 0.5rem 1.5rem;
`;

export const SectionTitle = styled.div`
    display: inline-block;
    font-size: 1.75rem;
    font-weight: bold;
    text-decoration: underline;
    margin-bottom: 1rem;
    margin-right: 0.5rem;
`;

export const GenericButton = styled.button`
    padding: 0.15rem 0.25rem;
    margin-left: 0.25rem;
    cursor: pointer;
`;

export const SmallGenericButton = styled.div`
    display:inline-block;
    margin-top: 0.35rem;
    margin-left: 0.5rem;
    font-size: 0.8rem;
    vertical-align: top;
    cursor: pointer;
    font-style: italic;
    color: blue;
    opacity: 0;
`;